// extracted by mini-css-extract-plugin
export default {"loader_container":"style_loader_container__nR9Bh","doc_container":"style_doc_container__fq9fA"};